import {ViewType} from "../../../../../../../../core/gd/const/views/view-type"
import {AddView_Group, AddView_GroupType} from "../../../../../../../../core/gd-ui/add-view/@types"
import {PROJECT_LIST_CONFIG} from "../../../../../../../../core/views/list/@config"
import AddViewPreviewDefaultForm from "../preview/forms/default-form"
import {PROJECT_TABLE_CONFIG} from "../../../../../../../../core/views/table/@config"
import {PROJECT_BOARD_CONFIG} from "../../../../../../../../core/views/board/@config"

export default function addView_projectTagConfig():AddView_Group[] {
    return [
        {
            type    : AddView_GroupType.GROUP,
            id      : 'tasks',
            icon    : 'i5-tasks',
            title   : 'Task Views',
            items   : [
                {
                    typeId      : ViewType.PROJECT_LIST,
                    iconSvg     : PROJECT_LIST_CONFIG.iconSvg,
                    title       : PROJECT_LIST_CONFIG.name,
                    description : PROJECT_LIST_CONFIG.description,
                    formComponent: AddViewPreviewDefaultForm,
                },
                {
                    typeId      : ViewType.PROJECT_TABLE,
                    iconSvg     : PROJECT_TABLE_CONFIG.iconSvg,
                    title       : PROJECT_TABLE_CONFIG.name,
                    description : PROJECT_TABLE_CONFIG.description,
                    formComponent: AddViewPreviewDefaultForm,
                },
                {
                    typeId      : ViewType.PROJECT_BOARD,
                    iconSvg     : PROJECT_BOARD_CONFIG.iconSvg,
                    title       : PROJECT_BOARD_CONFIG.name,
                    description : PROJECT_BOARD_CONFIG.description,
                    formComponent: AddViewPreviewDefaultForm,
                },
            ]

        }
    ]
}